import * as React from 'react'

export type Props = {
  children: React.ReactElement
  flashMessageHiddenCallback?: () => void
  timeout?: number
}

declare const process: {
  browser: boolean
}

const FlashMessage = ({ flashMessageHiddenCallback, timeout, children }: Props) => {
  const flashMessageRef = React.useRef()
  React.useEffect(() => {
    (flashMessageRef as any).current = setTimeout(() => {
      if (flashMessageHiddenCallback) {
        flashMessageHiddenCallback()
      }
    }, timeout)
    return () => {
      clearTimeout(flashMessageRef.current)
    }
  }, [])

  return children
}

FlashMessage.defaultProps = {
  timeout: 12000,
  flashMessageHiddenCallback: undefined,
}

export default FlashMessage